import { ComponentRenderProps } from '@json-render/react';

type DividerProps = ComponentRenderProps & {
  element: {
    props: Record<string, never>;
    children?: string[];
  };
};

export function Divider(_props: DividerProps) {
  return <hr className="border-t border-gray-200 my-3" />;
}
